// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"314":"4db73422","466":"2e6dc3d3","3084":"4db73422","4078":"c481ccaa"}[chunkId] + ".chunk.css";
};